import { DefaultPageSectionType } from '../../types';
import { FunctionComponent } from 'react';

const DefaultPageSection: FunctionComponent<DefaultPageSectionType> = ({
  heading,
  subheading,
  id,
  children,
  bgWhite = false,
  full = false,
  center = false,
  columns = false,
  className = '',
}) => {
  return (
    <section
      className={`${full ? 'fullpage-section' : columns ? 'section-column' : 'page-section'} ${
        bgWhite ? (columns ? 'section-column-white' : 'bg-white') : ''
      } ${className} ${center ? 'section-align-center' : ''}`}
      id={id}
    >
      <div className="container-xl">
        <div className="text-center">
          {center && full ? (
            <h1 className="section-heading fw-bold mb-4">{heading}</h1>
          ) : (
            <h2 className="section-heading fw-bold mb-4">{heading}</h2>
          )}
          <h4 className="section-subheading text-muted mb-4">{subheading}</h4>
          {children}
        </div>
      </div>
    </section>
  );
};

export default DefaultPageSection;
